export default "__VITE_ASSET__H8RUFgAs__"